import { ApiServiceV1 } from '@services/api.service';

export default {
  async getOrder({ suffix, id }) {
    const { data } = await ApiServiceV1.get(`${suffix}/order/${id}`);
    return data || {};
  },
  async getOrderHistory({ suffix, id }) {
    const { data } = await ApiServiceV1.get(`${suffix}/order/${id}/history`);
    return data || [];
  },
  async getOrderAttributes({ suffix, id }) {
    const { data } = await ApiServiceV1.get(`${suffix}/order/${id}/attributes`);
    return data || [];
  },
  async getOrders({
    suffix, state = null, validationState = null, outerId = null,
    customerId = null, printCustomer = null, pageNum = 1, pageSize = 10,
  }) {
    const { data } = await ApiServiceV1.get(`${suffix}/order`, {
      params: {
        state, validationState, outerId, customerId, printCustomer, pageNum, pageSize,
      },
    });
    return data || {};
  },
};
